import { isBrowser } from './is-browser';

export const loadYandexMap = (): Promise<void> =>
  new Promise((resolve, reject) => {
    if (isBrowser() && (window as any).ymaps) {
      resolve();
      return;
    }

    const script = document.createElement('script');

    script.src = 'https://api-maps.yandex.ru/2.1/?lang=en_US';
    script.type = 'text/javascript';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Yandex Maps'));
    document.head.appendChild(script);
  });
